import { useQuery } from '@apollo/client'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FullScreenLoader from '../Shared/FullScreenLoader'
import { useAppSelector } from '../../redux/store'
import {
  GET_HID_CONFIG,
  IGetHIDConfigData,
  IGetHIDConfigVars,
} from '../../graphql/hid/getHIDConfig'

const HIDServiceData = () => {
  const { t } = useTranslation(['hid'])
  const { tenantName } = useAppSelector(state => state.user)

  const { data, loading } = useQuery<IGetHIDConfigData, IGetHIDConfigVars>(
    GET_HID_CONFIG,
    {
      fetchPolicy: 'no-cache',
      variables: {
        name: tenantName,
      },
    },
  )

  const productData = [
    {
      label: t('number_of_cards'),
      value: data?.getTenant.hidConfig?.maxNumberOfMobileCards,
    },
    { label: t('used_cards'), value: data?.getTenant.employees.length },
    {
      label: t('active_cards'),
      value: data?.getTenant.employees.filter(
        ({ accounts }) => !!accounts[0].origoCards[0]?.deviceId,
      ).length,
    },
  ]

  if (loading) {
    return <FullScreenLoader />
  }

  if (!data?.getTenant?.hidConfig) {
    return null
  }

  return (
    <Box
      sx={{
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '26px',
        p: '24px 28px',
        mb: '20px',
        background: 'linear-gradient(120deg,#1A4A66 0%,#0E2C3B 58%)',
        boxShadow: '0 26px 54px -30px rgba(14,44,59,.65)',
        display: 'flex',
        gap: '0',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '-60px',
          left: '-20px',
          width: '220px',
          height: '220px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(237,189,1,0.18), transparent 70%)',
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '-70px',
          right: '40px',
          width: '240px',
          height: '240px',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(79,143,82,0.20), transparent 70%)',
          pointerEvents: 'none',
        }}
      />

      {/* stats */}
      <Box sx={{ position: 'relative', display: 'flex', gap: '0' }}>
        {productData.map((item, i) => (
          <Box
            key={item.label}
            sx={{
              px: i === 0 ? '0 32px 0 0' : '0 32px',
              pr: '32px',
              pl: i === 0 ? '0' : '32px',
              borderLeft:
                i > 0 ? '1px solid rgba(255,255,255,0.15)' : undefined,
            }}
          >
            <Typography
              sx={{
                fontSize: '11px',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: 'rgba(255,255,255,0.60)',
                fontWeight: 600,
                mb: '6px',
              }}
            >
              {item.label}
            </Typography>
            <Typography
              sx={{
                fontSize: '28px',
                fontWeight: 800,
                color: '#fff',
                lineHeight: 1,
              }}
            >
              {item.value ?? '—'}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default HIDServiceData
